export default {
    car_models: {},
    car_version:{}
}